import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DialogContent, Grid, LinearProgress } from '@material-ui/core';
import LateralPanel from '../../common/lateralPanel/LateralPanel';
import PanelHeaderIcon from '../../common/lateralPanel/PanelHeaderIcon';
import AlertComponent from '../../common/AlertComponent';
import ButtonConfirm from '../../common/Buttons/ButtonConfirm';
import DropDownZone from '../../common/DropDownZone';
import FileContent from '../../common/FileContent';
import iconDownload from '../../../resources/images/importIcon.png';

const MassivePriceUploadPanel = ({ open, onClose, onUpload, isSaving, onUploadSuccess }) => {
    const [files, setFiles] = useState([]);

    const cannotBeSaved = () => files.length === 0;

    const onRemoveFile = (fileId) => {
        const remaining = files.filter((file) => file.id !== fileId);
        setFiles(remaining);
    };

    const onSaveButtonClick = () => {
        if (onUpload) {
            onUpload(files, () => {
                setFiles([]); // Clear files only on success
                if (onUploadSuccess) onUploadSuccess();
            });
        }
    };

    return (
        <LateralPanel onClose={onClose} open={open}>
            <PanelHeaderIcon
                title={'UPLOAD MASSIVE PRICE'}
                isIconSvgOrPng={true}
                icon={iconDownload}
                onCloseButtonClick={onClose}
                canBeSaved={false}
            />
            <DialogContent>
                <Grid item xs={12}>
                    <AlertComponent
                        title={'Upload prices'}
                        message={'Upload your price template file in .xlsx format. Make sure the file is not damaged.'}
                        severityType={'info'}
                    />
                    <br />
                </Grid>
                <Grid item xs={12} style={{ marginBottom: '1em' }}>
                    {/* Optionally add a download template button here if you have a template */}
                </Grid>
                <Grid item xs={12}>
                    <DropDownZone
                        datacy='drop-zone-prices-massive'
                        multiple={false}
                        accept={'.xlsx'}
                        message={'Click here to add file'}
                        onFilesReceived={(newFiles) => {
                            const formattedFiles = newFiles.map((file) => ({
                                id: file.name + Date.now(),
                                attachment: file
                            }));
                            setFiles(formattedFiles);
                        }}
                        disabled={isSaving}
                    />
                </Grid>
                <Grid item xs={12}>
                    {files.length > 0 && <FileContent files={files} onRemoveFile={onRemoveFile} />}
                </Grid>
                <Grid item xs={12}>
                    <br />
                    {isSaving && <LinearProgress color='primary' />}
                    <br />
                    <ButtonConfirm
                        title={!isSaving ? 'UPLOAD' : 'UPLOADING...'}
                        onSavedClick={onSaveButtonClick}
                        disabled={cannotBeSaved() || isSaving}
                        isSaving={isSaving || cannotBeSaved()}
                    />
                </Grid>
            </DialogContent>
        </LateralPanel>
    );
};

MassivePriceUploadPanel.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
    isSaving: PropTypes.bool,
    onUploadSuccess: PropTypes.func,
};
MassivePriceUploadPanel.defaultProps = {
    isSaving: false,
};

export default MassivePriceUploadPanel;
